export default class ElementInView {
    constructor(elementsSelector, activeClass) {
        this.elementsSelector = elementsSelector;
        this.activeClass = activeClass;
        this.setupEvents();
        this.update();
    }

    setupEvents() {
        $(document).on('scroll', (ev) => { this.onScroll(ev); })
        $(window).on('resize', (ev) => { this.onResize(ev); })
    }

    onResize(ev) {
        this.update();
    }
    onScroll(ev) {
        this.update();
    }

    update() {
        $(this.elementsSelector).each((index, element) => {
            if (this.isItemInView(element)) {
                $(element).addClass(this.activeClass);
            } else {
                $(element).removeClass(this.activeClass);
            }
        })
    }

    isItemInView(element) {
        var windowHeight = $(window).height();
        var windowTop = $(window).scrollTop();
        var windowBottom = windowTop + windowHeight;
     
        var elementHeight = $(element).height();
        var elementTop = $(element).offset().top;
        var elementBottom = elementTop + elementHeight;
     
        return (windowBottom >= elementTop && windowTop <= elementBottom);
    };
}



// WEBPACK FOOTER //
// ./www/wp-content/themes/accelerator/assets/scripts/src/App/ElementInView.js